/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  GoogleRpcStatus,
  V2beta1Experiment,
  V2beta1ListExperimentsResponse,
} from '../models/index';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
  V2beta1ExperimentFromJSON,
  V2beta1ExperimentToJSON,
  V2beta1ListExperimentsResponseFromJSON,
  V2beta1ListExperimentsResponseToJSON,
} from '../models/index';

export interface ArchiveExperimentRequest {
  experiment_id: string;
}

export interface CreateExperimentRequest {
  experiment: V2beta1Experiment;
}

export interface DeleteExperimentRequest {
  experiment_id: string;
}

export interface GetExperimentRequest {
  experiment_id: string;
}

export interface ListExperimentsRequest {
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  filter?: string;
  namespace?: string;
}

export interface UnarchiveExperimentRequest {
  experiment_id: string;
}

/**
 *
 */
export class ExperimentServiceApi extends runtime.BaseAPI {
  /**
   * Archives an experiment and the experiment\'s runs and recurring runs.
   */
  async archiveExperimentRaw(
    requestParameters: ArchiveExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['experiment_id'] == null) {
      throw new runtime.RequiredError(
        'experiment_id',
        'Required parameter "experiment_id" was null or undefined when calling archiveExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v2beta1/experiments/{experiment_id}:archive`;
    urlPath = urlPath.replace(
      `{${'experiment_id'}}`,
      encodeURIComponent(String(requestParameters['experiment_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Archives an experiment and the experiment\'s runs and recurring runs.
   */
  async archiveExperiment(
    experiment_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.archiveExperimentRaw(
      { experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Creates a new experiment.
   */
  async createExperimentRaw(
    requestParameters: CreateExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Experiment>> {
    if (requestParameters['experiment'] == null) {
      throw new runtime.RequiredError(
        'experiment',
        'Required parameter "experiment" was null or undefined when calling createExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/apis/v2beta1/experiments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: V2beta1ExperimentToJSON(requestParameters['experiment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1ExperimentFromJSON(jsonValue),
    );
  }

  /**
   * Creates a new experiment.
   */
  async createExperiment(
    experiment: V2beta1Experiment,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Experiment> {
    const response = await this.createExperimentRaw({ experiment: experiment }, initOverrides);
    return await response.value();
  }

  /**
   * Deletes an experiment without deleting the experiment\'s runs and recurring  runs. To avoid unexpected behaviors, delete an experiment\'s runs and recurring  runs before deleting the experiment.
   */
  async deleteExperimentRaw(
    requestParameters: DeleteExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['experiment_id'] == null) {
      throw new runtime.RequiredError(
        'experiment_id',
        'Required parameter "experiment_id" was null or undefined when calling deleteExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v2beta1/experiments/{experiment_id}`;
    urlPath = urlPath.replace(
      `{${'experiment_id'}}`,
      encodeURIComponent(String(requestParameters['experiment_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes an experiment without deleting the experiment\'s runs and recurring  runs. To avoid unexpected behaviors, delete an experiment\'s runs and recurring  runs before deleting the experiment.
   */
  async deleteExperiment(
    experiment_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteExperimentRaw(
      { experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds a specific experiment by ID.
   */
  async getExperimentRaw(
    requestParameters: GetExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Experiment>> {
    if (requestParameters['experiment_id'] == null) {
      throw new runtime.RequiredError(
        'experiment_id',
        'Required parameter "experiment_id" was null or undefined when calling getExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v2beta1/experiments/{experiment_id}`;
    urlPath = urlPath.replace(
      `{${'experiment_id'}}`,
      encodeURIComponent(String(requestParameters['experiment_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1ExperimentFromJSON(jsonValue),
    );
  }

  /**
   * Finds a specific experiment by ID.
   */
  async getExperiment(
    experiment_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Experiment> {
    const response = await this.getExperimentRaw({ experiment_id: experiment_id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds all experiments. Supports pagination, and sorting on certain fields.
   */
  async listExperimentsRaw(
    requestParameters: ListExperimentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1ListExperimentsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    if (requestParameters['namespace'] != null) {
      queryParameters['namespace'] = requestParameters['namespace'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v2beta1/experiments`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      V2beta1ListExperimentsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all experiments. Supports pagination, and sorting on certain fields.
   */
  async listExperiments(
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    filter?: string,
    namespace?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1ListExperimentsResponse> {
    const response = await this.listExperimentsRaw(
      {
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        filter: filter,
        namespace: namespace,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Restores an archived experiment. The experiment\'s archived runs and recurring runs will stay archived.
   */
  async unarchiveExperimentRaw(
    requestParameters: UnarchiveExperimentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['experiment_id'] == null) {
      throw new runtime.RequiredError(
        'experiment_id',
        'Required parameter "experiment_id" was null or undefined when calling unarchiveExperiment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v2beta1/experiments/{experiment_id}:unarchive`;
    urlPath = urlPath.replace(
      `{${'experiment_id'}}`,
      encodeURIComponent(String(requestParameters['experiment_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Restores an archived experiment. The experiment\'s archived runs and recurring runs will stay archived.
   */
  async unarchiveExperiment(
    experiment_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.unarchiveExperimentRaw(
      { experiment_id: experiment_id },
      initOverrides,
    );
    return await response.value();
  }
}
